import XOConnectService from "@core/services/XOConnectService";
import { Client } from "@custom-types/Client";
import React, { Component } from "react";
import { connect } from "react-redux";
import WebViewBase from "./WebViewBase";

interface Props {
    source: string
    client: Client
}

interface State {
    loading: boolean;
    enabledReload: boolean;
}

class _WebViewXOConnect extends Component<Props, State> {
    WebViewBaseRef: WebViewBase;
    XOService: XOConnectService;

    constructor(props: Props) {
        super(props);
        this.listenOnMessage = this.listenOnMessage.bind(this);
    }

    componentDidMount(): void {
     
    }

    listenOnMessage = (payload) => {
  
        
        this.XOService.handleRequests(payload)
    };
  

    render() {
        return (
            <WebViewBase
                ref={(r) => {
                    this.WebViewBaseRef = r;
                    this.XOService = new XOConnectService(r, this.props.client)
                }}
                onMessage={this.listenOnMessage}
                source={this.props.source}
                onLoadJavascript={XOConnectService.xoConnectListener(this.WebViewBaseRef)}
                style={{ flex: 1}}
            ></WebViewBase>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        client: state.auth.client,
    };
};

const mapDispatchToProps = (dispatch) => ({});

const WebViewXOConnect = connect(mapStateToProps, mapDispatchToProps)(_WebViewXOConnect);

export default WebViewXOConnect;
